import { application } from "./application"

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import ConversionProgressController from "./conversion_progress_controller"
application.register("conversion-progress", ConversionProgressController)

import BulkEditController from "./bulk_edit_controller"
application.register("bulk-edit", BulkEditController)
